import { ThemeKey } from "@smartsheet/design-tokens";
import React, { forwardRef, HTMLAttributes } from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { isUrsa } from "../../../../util/themeHelper";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { OptionBaseStyled, OptionBaseStyledProps } from "./OptionBaseStyled";

export interface OptionBaseProps extends Omit<OptionBaseStyledProps, "themeMode">, HTMLAttributes<HTMLDivElement> {}

export const OptionBase = forwardRef<HTMLDivElement, OptionBaseProps>((props, ref) => {
    const { key } = useTheme();
    const themeMode = key as ThemeKey;
    const optionHeight =
        props.height ?? isUrsa(themeMode)
            ? menuTheme.optionHeight.dense(themeMode)
            : menuTheme.optionHeight.normal(themeMode);
    return <OptionBaseStyled {...props} height={optionHeight} themeMode={themeMode} ref={ref} />;
});

OptionBase.displayName = "OptionBase";
